module.exports = __webpack_public_path__ + "assets/img/whybuyaudiapproved2.1df8a42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/whybuyaudiapproved2.jpg
// module id = VZcx
// module chunks = 1